<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">The Arrow Academy</h1>
<ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#acknowledgment">Acknowledgment</a></li>
<li id="toc-li-5"><a href="#/text/ch005#the-arrow-academy-yearbook">The Arrow Academy Yearbook</a></li>
<li id="toc-li-6"><a href="#/text/ch006#chapter-1-a-not-so-average-day">Chapter 1 A Not-So-Average Day</a></li>
<li id="toc-li-7"><span href="#/text/ch007#chapter-2-the-last-day" title="Link target outside of Sample">Chapter 2 The Last Day</span></li>
<li id="toc-li-8"><span href="#/text/ch008#chapter-3-the-worst-day" title="Link target outside of Sample">Chapter 3 The Worst Day</span></li>
<li id="toc-li-9"><span href="#/text/ch009#chapter-4-the-first-day" title="Link target outside of Sample">Chapter 4 The First Day</span></li>
<li id="toc-li-10"><span href="#/text/ch010#chapter-5-the-most-embarrassing-day" title="Link target outside of Sample">Chapter 5 The Most Embarrassing Day</span></li>
<li id="toc-li-11"><span href="#/text/ch011#chapter-6-birthday" title="Link target outside of Sample">Chapter 6 Birthday</span></li>
<li id="toc-li-12"><span href="#/text/ch012#chapter-7-field-day" title="Link target outside of Sample">Chapter 7 Field Day</span></li>
<li id="toc-li-13"><span href="#/text/ch013#chapter-8-testing-day" title="Link target outside of Sample">Chapter 8 Testing Day</span></li>
<li id="toc-li-14"><span href="#/text/ch014#chapter-9-christmas-day" title="Link target outside of Sample">Chapter 9 Christmas Day</span></li>
<li id="toc-li-15"><span href="#/text/ch015#chapter-10-the-take-down-day" title="Link target outside of Sample">Chapter 10 The Take Down Day</span></li>
<li id="toc-li-16"><span href="#/text/ch016#chapter-11-training-day" title="Link target outside of Sample">Chapter 11 Training Day</span></li>
<li id="toc-li-17"><span href="#/text/ch017#chapter-12-the-saving-day" title="Link target outside of Sample">Chapter 12 The Saving Day</span></li>
<li id="toc-li-18"><span href="#/text/ch018#chapter-13-back-to-a-normal-day" title="Link target outside of Sample">Chapter 13 Back to a Normal Day</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?5a54fd7c